// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2sqhp","image":"styles_image__3rUG7","title":"styles_title__Dnf7t"};